export default __webpack_public_path__ + "static/replay-light-mode-4a73205020a5d51f75db80ef6acf7ed9.mp4";